import type {
  SearchResponse,
  SearchResultsResponse,
  SearchSuggestResponse,
} from "@/features/search/types";
import type {
  SearchResponseDto,
  SearchResultsResponseDto,
  SearchSuggestResponseDto,
} from "../dto/search.dto";

export function mapSearchResponseDto(dto: SearchResponseDto): SearchResponse {
  return dto;
}

export function mapSearchResultsDto(dto: SearchResultsResponseDto): SearchResultsResponse {
  return dto;
}

export function mapSearchSuggestDto(dto: SearchSuggestResponseDto): SearchSuggestResponse {
  return dto;
}
